<ng-container *ngIf="!!table">
  <jb-table
    class="jb-table mt6 mt4-ns mb6"
    [title]="table?.tableName"
    [type]="table?.type"
    [legal]="!!table?.legal ? table?.legal : []"
    [headers]="table?.headers"
    [rows]="table?.rows"
    [tableData]="table?.tableData"
  >
  </jb-table>
</ng-container>
